import Icon from "../../../Icon";
import React from 'react';
import "./index.less";
var FooterMedia = function FooterMedia(props) {
  var _props$data = props.data,
    data = _props$data === void 0 ? [] : _props$data;
  return /*#__PURE__*/React.createElement("div", {
    className: "iron-footer-media"
  }, /*#__PURE__*/React.createElement("ul", {
    className: "iron-footer-media-flex"
  }, data && data.map(function (subItem, index) {
    return /*#__PURE__*/React.createElement("li", {
      className: "iron-footer-media-icon",
      key: index
    }, /*#__PURE__*/React.createElement("a", {
      target: subItem === null || subItem === void 0 ? void 0 : subItem.target,
      rel: "noopener noreferrer",
      href: subItem === null || subItem === void 0 ? void 0 : subItem.href
    }, /*#__PURE__*/React.createElement(Icon, {
      name: String(subItem === null || subItem === void 0 ? void 0 : subItem.icon)
    })));
  })));
};
export default FooterMedia;